import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import Nav from "../Nav/Nav";
import "./soon.css";

export default function Soon() {
  return (
    <div className="content">
      <div className="rectangle"></div>
      <Nav />
      <Header />
      <Footer />
    </div>
  );
}
